export default __webpack_public_path__ + "static/media/meiro-labyrinth.b014bc0f.svg";